import React, { useEffect, useState } from "react";
import Payment from "../../components/Payment";
import { useLocation, useNavigate } from "react-router-dom";
import { Backdrop, CircularProgress, Container } from "@mui/material";
import { ApiCallStatus, PaymentType } from "../../utils/constants";
import {
	fetchAvailablePaymentMethodsData,
	fetchPaymentOrderData
} from "../PageFunctions/paymentFunctions";
import { useArgusAuth } from "../../hooks/useArgusAuth";
import {isNil} from "lodash";



const PaymentPage = ({
	genericDataLoaded,
	genericPageContent
}) => {
	const {isAuthenticated, isLoading} = useArgusAuth();
	const location = useLocation();
	const navigate = useNavigate();
	const [accountCreditPaymentOrderInfo, setAccountCreditPaymentOrderInfo] = useState(null);
	const [paymentMethods, setPaymentMethods] = useState(null);

	const [accountCreditPaymentOrderInfoCallStatus, setAccountCreditPaymentOrderInfoCallStatus] = useState(ApiCallStatus.NotStarted);
	const [fetchAvailablePaymentMethodsDataCallStatus, setFetchAvailablePaymentMethodsDataCallStatus] = useState(ApiCallStatus.NotStarted);

	const gotoLoginPage = () => navigate("/login", {state: {from: location}});
	const gotoPaymentPayfastCredit = () => navigate(`/payment/payfast`);
	const gotoPaymentAccountCredit = () => navigate(`/payment/account-credit`);
	const gotoPaymentEftPage = () => navigate(`/payment/eft`);
	const gotoPaymentCreditCardOnCollectionPage = () => navigate(`/payment/credit-card-on-collection`);


	const fetchAvailablePaymentMethodsDataAsync = async () => {
		await fetchAvailablePaymentMethodsData({
			setPaymentMethods,
			setStatusInProgress: () => setFetchAvailablePaymentMethodsDataCallStatus(ApiCallStatus.InProgress),
			setStatusSuccess: () => setFetchAvailablePaymentMethodsDataCallStatus(ApiCallStatus.Succeeded),
			setStatusFailed: () => setFetchAvailablePaymentMethodsDataCallStatus(ApiCallStatus.Failed),
			setStatusError: () => setFetchAvailablePaymentMethodsDataCallStatus(ApiCallStatus.Error)
		});
	};

	const fetchAccountCreditPaymentOrderDataAsync = async () => {
		await fetchPaymentOrderData({
			paymentType: PaymentType.AccountCredit,
			setPaymentOrderInfo: setAccountCreditPaymentOrderInfo,
			setStatusInProgress: () => setAccountCreditPaymentOrderInfoCallStatus(ApiCallStatus.InProgress),
			setStatusSuccess: () => setAccountCreditPaymentOrderInfoCallStatus(ApiCallStatus.Succeeded),
			setStatusFailed: () => setAccountCreditPaymentOrderInfoCallStatus(ApiCallStatus.Failed),
			setStatusError: () => setAccountCreditPaymentOrderInfoCallStatus(ApiCallStatus.Error)
		});
	};

	const authorizedPageLoad = async () => {

	};

	const unAuthorizedPageLoad = async () => {
		await fetchAvailablePaymentMethodsDataAsync();
	};

	useEffect(() => {
		if (genericDataLoaded === true && isLoading === false) {
			if (isAuthenticated === false) {
				gotoLoginPage();
			} else {
				authorizedPageLoad();
				unAuthorizedPageLoad();
			}
		}
	}, [genericDataLoaded, isAuthenticated, isLoading]);


	useEffect(() => {
		if (genericDataLoaded && !isNil(genericPageContent?.tecfinityAvailableCredit)) {
			fetchAccountCreditPaymentOrderDataAsync();
		}
	}, [genericDataLoaded, genericPageContent]);

	const allLoadingStates = [
		accountCreditPaymentOrderInfoCallStatus,
		fetchAvailablePaymentMethodsDataCallStatus
	];

	const pageIsLoading = allLoadingStates.includes(ApiCallStatus.InProgress) || genericDataLoaded === false || isLoading === true;

	return (
		<Container maxWidth="lg">
			<Payment
				accountCreditPaymentOrderInfo={accountCreditPaymentOrderInfo}
                tecfinityAvailableCredit={genericPageContent?.tecfinityAvailableCredit}
				tradeAccount={genericPageContent?.tradeAccount}
				paymentMethods={paymentMethods}
				gotoPaymentPayfastPage={gotoPaymentPayfastCredit}
				gotoPaymentAccountCredit={gotoPaymentAccountCredit}
				gotoPaymentEftPage={gotoPaymentEftPage}
				gotoPaymentCreditCardOnCollectionPage={gotoPaymentCreditCardOnCollectionPage}
			/>
			<Backdrop
				sx={{color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1}}
				open={pageIsLoading}
			>
				<CircularProgress color="inherit"/>
			</Backdrop>
		</Container>
	);
};
export default PaymentPage;
